/** Angular Imports */
import { Component, inject } from '@angular/core';

/** Core Imports */
import { CreateUserStepsService } from '@core';

/** Constant Imports */
import { USER_ROLES } from '@features/users/constants';

/** Interface Imports */
import { UserRoles } from '@features/users/interfaces';

@Component({
    selector: 'app-create-new-user',
    imports: [],
    templateUrl: './create-new-user.component.html',
    styleUrl: './create-new-user.component.scss',
})
export class CreateNewUserComponent {
    /**
     * Layout constant user roles
     */
    protected userRoles = USER_ROLES;

    /**
     * Inject create user service to commnicate with other sub-steps
     */
    private createUserStepsService = inject(CreateUserStepsService);

    /**
     * Handle user role selection
     */
    protected onUserRoleSelected(userRole: { id: UserRoles; label: string }): void {
        this.createUserStepsService.setUserType(userRole);
        this.createUserStepsService.goNextStep();
    }
}
